import { render } from "./DropdownCheckbox.vue?vue&type=template&id=01f2cded"
import script from "./DropdownCheckbox.vue?vue&type=script&lang=js"
export * from "./DropdownCheckbox.vue?vue&type=script&lang=js"

import "./DropdownCheckbox.vue?vue&type=style&index=0&id=01f2cded&lang=scss"

import exportComponent from "/Volumes/Storage/WebDevelopment/Fintax/new-gitlab/pajak.io/frontend-library-component-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__